import { useEffect } from "react";
import useVoice from "../../../app/hooks/useVoice";

const VoiceTextbox = ({ command, param, type, min, className, disabled, style, value, onChange, onKeyDown, onBlur, setValue }) => {
    const { isListening, action } = useVoice();
    const computedClassName = `${className || ""} ${isListening && !disabled ? "voice-button-listening" : ""}`.trim();

    // Split commands and create data attributes dynamically
    const commandList = command ? command.split(",").map(cmd => cmd.trim()) : [];
    const commandAttributes = commandList.reduce((attrs, cmd, index) => {
        attrs[`data-command-${index + 1}`] = cmd.toLowerCase();
        return attrs;
    }, {});

    useEffect(() => {
        if (action && action?.command) {
            if (command.toLowerCase() === action.command.toLowerCase() && action?.params && action?.params.hasOwnProperty(param)) {
                setValue(action?.params[param])
            }
        }
    }, [action]);

    return (
        <span
            className={isListening && !disabled ? "voice-button-listening1" : ""}
            data-title={command ? `You can say: ${command}` : undefined}
        >
            <input type={type || "text"}
                {...(min !== undefined ? { min } : {})}
                {...commandAttributes}  // Add dynamic data-command attributes
                {...(style ? { style } : {})}
                {...(disabled !== undefined ? { disabled } : {})}
                {...(value !== undefined ? { value } : {})}
                {...(onKeyDown ? { onKeyDown } : {})}
                {...(onBlur ? { onBlur } : {})}
                {...(onChange ? { onChange } : {})}
                className={computedClassName}
            />
        </span>
    );
};


export default VoiceTextbox;